import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchSpamChecksByIds } from '@app/api'

export const fetchSpamChecksThunk = createAsyncThunk(
  'spam/fetchSpamChecks',
  async (ids: number[], { signal }) => {
    return await fetchSpamChecksByIds(ids, signal)
  }
)
